interface Props {
  status: 'active' | 'suspended' | 'setup_mode' | 'cancelled' | 'archived';
}

const statusConfig = {
  active: {
    label: 'Active',
    className: 'bg-green-100 text-green-800 border-green-200',
  },
  suspended: {
    label: 'Suspended',
    className: 'bg-red-100 text-red-800 border-red-200',
  },
  setup_mode: {
    label: 'Setup',
    className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'bg-gray-100 text-gray-600 border-gray-200',
  },
  archived: {
    label: 'Archived',
    className: 'bg-gray-100 text-gray-500 border-gray-200',
  },
};

export default function StatusBadge({ status }: Props) {
  const config = statusConfig[status];
  return (
    <span
      className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className}`}
    >
      {config.label}
    </span>
  );
}
